<template lang="html">
    <div class="d-flex flex-wrap">

        <div
            class="payMethod radius-normal text-center border-medium py-3 d-flex flex-column justify-content-between mr-2 mb-2 pointer"
            @click="selectPayMethod(paymentMethod)"
            :class="{selected: selectedMethod != null && paymentMethod.id == selectedMethod.id, 'disabled':paymentMethod.disabled}"
            v-for="paymentMethod in filteredPaymentMethods"
        >
            <div>
                <i v-if="paymentMethod.icon" class="ico dark fs-largest m-0" :class="paymentMethod.icon"></i>
                <img v-else-if="paymentMethod.img" :src="paymentMethod.img" :alt="paymentMethod.description" style="max-width: 60%;">
            </div>
            <span class="payeLabel darkest font-weight-600">{{paymentMethod.description}}</span>
        </div>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    created: function () {
        // select correct payment method:
        this.selectedMethod = this.getPaymentTypeListAll.find(item => {return item.id == this.value})
        this.allowedMethodsLocal = this.allowedMethods
    },
    data: function () {
        return {
            selectedMethod: null,
            allowedMethodsLocal: null
        }
    },
    props: {
        value: {
            type: Number
        },
        allowedMethods:{
            type: Array,
            default: null
        },
    },
    computed: {
        ...mapGetters([
            'getPaymentTypeListAll'
        ]),
        filteredPaymentMethods: function () {
            // return this.getPaymentTypeListAll.filter(paymentMethod => this.allowedMethodsLocal.includes(paymentMethod.id))
            return this.getPaymentTypeListAll.map(paymentMethod => {
                if(this.allowedMethodsLocal != null && !this.allowedMethodsLocal.includes(paymentMethod.id)){
                    paymentMethod.disabled = true
                } else {
                    paymentMethod.disabled = false
                }
                return paymentMethod
            })
        }
    },
    methods: {
        selectPayMethod: function (paymentMethod) {
            if(paymentMethod.disabled == true){
                return false
            }

            this.selectedMethod = paymentMethod
            // this.value = paymentMethod.id
            this.$emit('input', paymentMethod.id)
            this.$emit('change', paymentMethod.id)
        },
        deselectPaymentMethod: function () {
            this.selectedMethod = null
            this.$emit('change', null)
        }
    },
    watch: {
        allowedMethods: {
            handler(val) {
                this.allowedMethodsLocal = val
                this.$forceUpdate()
            },
            immedoate: true
        },
        value: {
            handler(val) {
                if(val == null){
                    this.deselectPaymentMethod()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';
@import "~@/assets/scss/_utility.scss";

.payMethod{
    width: 103px;
    height: 72px;
    position: relative;

    .payeLabel{
        position: absolute;
        bottom: 7px;
        width: 100%;
    }

    &.disabled{
        opacity: 0.5;
        background-color: $light;
        cursor: not-allowed !important;
    }

    &.selected{
        @extend .border-darker;
        border-width: 2px !important;
        background-color: $color-3 !important;
        color: $lightest !important;

        *{
            color: $lightest !important;
        }
    }

    &:hover{
        background-color: $lighter;
    }
}
</style>



// WEBPACK FOOTER //
// PaymentMethodPicker.vue?11dd9322